// Constants

/**
 * Custom options for custom scoring connection method
 */
export const httpConnectionOptions = [
  { label: 'GET', id: 'get' },
  { label: 'POST', id: 'post' },
  { label: 'PATCH', id: 'patch' },
  { label: 'PUT', id: 'put' }
];

/**
 * Used in custom scoring acceptance parsing
 */
export const acceptanceParsingComparisonConfig = {
  options: [
    { label: 'Equals', value: '===' },
    { label: 'Does Not Equal', value: '!=' },
    { label: 'Greater Than', value: '>' },
    { label: 'Less Than', value: '<' }
  ],
  placeholder: 'Choose Operator'
};

export const regexForParsing = {
  operaterRegex: />|<|===|!=/,
  valueRegex: /"([^"]+)"/,
  valueRegexInt: /(\d+)/,
}